// extracted by mini-css-extract-plugin
export default {"inputlabel":"style_inputlabel__lVMs0","inputbox":"style_inputbox__WwJno"};